import { TFnType } from '@tolgee/react'

const ordinalize = (
  t: (key: string, params?: Record<string, any>) => string,
  n: number,
) => {
  if (n % 10 === 1) return t('common.ordinal.first', { n })
  if (n % 10 === 2) return t('common.ordinal.second', { n })
  if (n % 10 === 3) return t('common.ordinal.third', { n })
  return t('common.ordinal.nth', { n })
}

/**
 * We have tolgee keys for the default group names
 * Custom group names fall back to the user-defined name
 */
const localizedGroupName = (t: TFnType, groupName: string) => {
  const key = `groups.name.${groupName.toLowerCase()}`
  // @tolgee-ignore
  return t(key, groupName)
}

export const LocalizationHelpers = {
  ordinalize,
  localizedGroupName,
}
